export const getErrorMessage = (e: any): string => {
  if (!e) return '';
  const raw = e?.responseData?.errorMessage || e.message || '';
  // String() guards against a numeric errorMessage, where .replace would throw.
  return String(raw).replace('Error:', '');
};

export const getErrorCode = (e: any): number => {
  // Prefer errorCode; fall back to the legacy errorMessage-as-code, then ErrorWithCode.code.
  const errCode: number = e?.responseData?.errorCode || e?.responseData?.errorMessage || e?.code || 0;
  return errCode;
};

const SBTS_ERROR_CODES = [410, 1021];

export const isSBTSError = (e: { responseData?: { errorMessage: string; errorCode: number }; code?: number }) => {
  const errorCode = e?.responseData?.errorCode || e?.code || 0;
  return SBTS_ERROR_CODES.includes(errorCode);
};

export const isInternalEvent403Error = (e: {
  responseData?: { errorMessage: string; errorCode: number };
  code?: number;
}) => {
  const errorCode = e?.responseData?.errorCode || e?.code || 0;
  return errorCode === 453;
};
